// import React, { useState, useEffect, useRef } from 'react';
// import { MessageCircle, X, ArrowUp } from 'lucide-react';
// import { motion, AnimatePresence } from 'framer-motion';
// import { useTranslation } from 'react-i18next';
// import axios from 'axios';

// const ChatWidget = () => {
//   const { t } = useTranslation();
//   const [open, setOpen] = useState(false);
//   const [messages, setMessages] = useState([]);
//   const [input, setInput] = useState('');
//   const [isLoading, setIsLoading] = useState(false);
//   const [isFetching, setIsFetching] = useState(false);
//   const [matrimonyId, setMatrimonyId] = useState(localStorage.getItem('MatrimonyId'));
//   const [connectionStatus, setConnectionStatus] = useState('disconnected');
//   const messagesEndRef = useRef(null);

//   const ADMIN_EMAIL = 'newbrindhaadminpage@gmail.com';

//   useEffect(() => {
//     const handleAuthChange = () => {
//       const currentId = localStorage.getItem('MatrimonyId');
//       if (currentId !== matrimonyId) {
//         if (matrimonyId && !currentId) {
//           // User logged out
//           setMessages([]);
//           setInput('');
//           setConnectionStatus('disconnected');
//         }
//         setMatrimonyId(currentId);
//       }
//     };

//     const handleStorageChange = (e) => {
//       if (e.key === 'MatrimonyId') {
//         handleAuthChange();
//       }
//     };

//     const interval = setInterval(handleAuthChange, 5000);

//     window.addEventListener('storage', handleStorageChange);

//     return () => {
//       clearInterval(interval);
//       window.removeEventListener('storage', handleStorageChange);
//     };
//   }, [matrimonyId]);

//   useEffect(() => {
//     scrollToBottom();
//   }, [messages]);

//   const scrollToBottom = () => {
//     messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
//   };

//   const fetchMessages = async () => {
//     if (!matrimonyId || isFetching) return;

//     setIsFetching(true);

//     try {
//       const token = localStorage.getItem('authToken');
//       if (!token) {
//         setConnectionStatus('disconnected');
//         return;
//       }

//       const getUrl = `https://backend.newbrindha.com/matrimony/chat/admin/messages?matrimony_id=${matrimonyId}&t=${Date.now()}`;

//       const response = await axios.get(getUrl, {
//         headers: { Authorization: `Bearer ${token}` },
//         timeout: 10000
//       });

//       if (response.data && Array.isArray(response.data)) {
//         const formattedMessages = response.data.map(msg => ({
//           id: `${msg.timestamp}-${msg.sender_id}`,
//           sender: msg.sender_id === 'admin' ? 'admin' : 'user',
//           text: msg.message,
//           timestamp: msg.timestamp
//         })).sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));

//         setMessages(formattedMessages);
//         setConnectionStatus('connected');
//       }
//     } catch (err) {
//       console.error('Chat: Error fetching messages:', err);
//       setConnectionStatus('error');
//     } finally {
//       setIsFetching(false);
//     }
//   };

//   useEffect(() => {
//     let interval;

//     if (open && matrimonyId) {
//       fetchMessages();

//       if (connectionStatus !== 'connected') {
//         interval = setInterval(fetchMessages, 3000);
//       }
//     }

//     return () => {
//       if (interval) clearInterval(interval);
//     };
//   }, [open, matrimonyId, connectionStatus]);

//   const handleSend = async () => {
//     if (!input.trim() || !matrimonyId || isLoading) return;

//     const userMsg = {
//       id: `user-${Date.now()}`,
//       sender: 'user',
//       text: input.trim(),
//       timestamp: new Date().toISOString()
//     };

//     setMessages(prev => [...prev, userMsg]);
//     setInput('');
//     setIsLoading(true);

//     try {
//       const token = localStorage.getItem('authToken');
//       if (!token) {
//         throw new Error('Authentication token not found');
//       }

//       await axios.post(
//         'https://backend.newbrindha.com/matrimony/chat/user-to-admin',
//         {
//           message: input.trim(),
//           sender_id: matrimonyId,
//           receiver_email: ADMIN_EMAIL,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//           timeout: 10000
//         }
//       );

//       await fetchMessages();
//     } catch (err) {
//       console.error('Chat: Error sending message:', err);
//       setMessages(prev => prev.filter(msg => msg.id !== userMsg.id));
//       setInput(userMsg.text);
//       setTimeout(handleSend, 2000);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const getConnectionStatus = () => {
//     switch (connectionStatus) {
//       case 'connected':
//         return (
//           <div className="flex items-center text-xs text-green-600">
//             <div className="w-2 h-2 bg-green-500 rounded-full mr-1"></div>
//             Connected
//           </div>
//         );
//       case 'connecting':
//         return (
//           <div className="flex items-center text-xs text-amber-600">
//             <div className="w-2 h-2 bg-amber-500 rounded-full mr-1 animate-pulse"></div>
//             Connecting...
//           </div>
//         );
//       case 'error':
//         return (
//           <div className="flex items-center text-xs text-amber-600">
//             <div className="w-2 h-2 bg-amber-500 rounded-full mr-1"></div>
//             Reconnecting...
//           </div>
//         );
//       default:
//         return (
//           <div className="flex items-center text-xs text-gray-500">
//             <div className="w-2 h-2 bg-gray-400 rounded-full mr-1"></div>
//             Disconnected
//           </div>
//         );
//     }
//   };

//   return (
//     <div className="fixed bottom-6 right-6 z-50" style={{ width: 'auto', height: 'auto' }}>
//       <AnimatePresence>
//         {!open && (
//           <motion.button
//             key="chat-button"
//             onClick={() => setOpen(true)}
//             className="bg-gradient-to-r from-amber-500 to-orange-500 text-white p-4 rounded-full shadow-xl hover:shadow-2xl"
//             whileHover={{ scale: 1.1 }}
//             whileTap={{ scale: 0.95 }}
//             aria-label="Open chat"
//             initial={{ opacity: 0, scale: 0.5 }}
//             animate={{ opacity: 1, scale: 1 }}
//             exit={{ opacity: 0, scale: 0.5 }}
//             transition={{ type: 'spring', stiffness: 500, damping: 30 }}
//           >
//             <MessageCircle className="w-6 h-6" />
//           </motion.button>
//         )}
//       </AnimatePresence>

//       <AnimatePresence>
//         {open && (
//           <motion.div
//             key="chat-window"
//             className="w-80 bg-white rounded-2xl shadow-2xl flex flex-col overflow-hidden border border-gray-200"
//             initial={{ opacity: 0, scale: 0.8, y: 20 }}
//             animate={{ opacity: 1, scale: 1, y: 0 }}
//             exit={{ opacity: 0, scale: 0.8, y: 20 }}
//             transition={{
//               type: 'spring',
//               damping: 25,
//               stiffness: 300,
//             }}
//           >
//             <div className="bg-gradient-to-r from-amber-500 to-orange-500 text-white px-4 py-3 flex justify-between items-center">
//               <div className="flex items-center space-x-2">
//                 <div className="w-3 h-3 bg-white rounded-full"></div>
//                 <span className="font-medium">Admin Chat</span>
//               </div>
//               <div className="flex items-center space-x-3">
//                 {getConnectionStatus()}
//                 <button
//                   onClick={() => setOpen(false)}
//                   className="p-1 rounded-full hover:bg-white/20 transition-colors"
//                   aria-label="Close chat"
//                 >
//                   <X className="w-5 h-5" />
//                 </button>
//               </div>
//             </div>

//             <div className="flex-1 p-4 space-y-3 overflow-y-auto max-h-80 bg-gray-50">
//               {!matrimonyId ? (
//                 <div className="text-center p-4 text-sm bg-amber-50 rounded-lg border border-amber-100 text-amber-800">
//                   Please login to access chat
//                 </div>
//               ) : isFetching && messages.length === 0 ? (
//                 <div className="flex justify-center items-center h-40">
//                   <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-amber-500"></div>
//                 </div>
//               ) : messages.length === 0 ? (
//                 <div className="text-center p-4 text-sm bg-amber-50 rounded-lg border border-amber-100 text-amber-800">
//                   <div className="mb-2">👋</div>
//                   <div>Welcome! Send a message to chat with our admin.</div>
//                 </div>
//               ) : (
//                 messages.map((msg) => (
//                   <motion.div
//                     key={msg.id}
//                     className={`flex ${msg.sender === 'user' ? 'justify-end' : 'justify-start'}`}
//                     initial={{ opacity: 0, y: 10 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     transition={{ duration: 0.2 }}
//                   >
//                     <div
//                       className={`px-4 py-2 rounded-2xl max-w-[80%] ${
//                         msg.sender === 'user'
//                           ? 'bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-br-none'
//                           : 'bg-white text-gray-800 rounded-bl-none shadow-sm border border-gray-200'
//                       }`}
//                     >
//                       {msg.text}
//                       <div className={`text-xs mt-1 ${msg.sender === 'user' ? 'text-amber-100' : 'text-gray-500'}`}>
//                         {new Date(msg.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
//                       </div>
//                     </div>
//                   </motion.div>
//                 ))
//               )}
//               <div ref={messagesEndRef} />
//             </div>

//             <div className="border-t border-gray-200 p-3 bg-white">
//               <div className="flex items-center">
//                 <input
//                   className="flex-1 border border-gray-300 rounded-l-full px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent"
//                   type="text"
//                   value={input}
//                   placeholder={matrimonyId ? "Type your message..." : "Please login to chat"}
//                   onChange={(e) => setInput(e.target.value)}
//                   onKeyDown={(e) => e.key === 'Enter' && handleSend()}
//                   disabled={isLoading || !matrimonyId}
//                 />
//                 <button
//                   className="bg-gradient-to-r from-amber-500 to-orange-500 text-white p-2 rounded-r-full hover:opacity-90 transition-opacity disabled:opacity-50"
//                   onClick={handleSend}
//                   disabled={!input.trim() || isLoading || !matrimonyId}
//                 >
//                   {isLoading ? (
//                     <div className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full"></div>
//                   ) : (
//                     <ArrowUp className="w-4 h-4" />
//                   )}
//                 </button>
//               </div>
//             </div>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </div>
//   );
// };

// export default ChatWidget;

import React, { useState, useEffect, useRef } from "react";
import { MessageCircle, X, ArrowUp } from "lucide-react";
import { useTranslation } from "react-i18next";
import axios from "axios";

const ChatWidget = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [matrimonyId, setMatrimonyId] = useState(
    localStorage.getItem("MatrimonyId"),
  );
  const [connectionStatus, setConnectionStatus] = useState("disconnected");
  const messagesEndRef = useRef(null);

  const ADMIN_EMAIL = "newbrindhaadminpage@gmail.com";

  useEffect(() => {
    const handleAuthChange = () => {
      const currentId = localStorage.getItem("MatrimonyId");
      if (currentId !== matrimonyId) {
        if (matrimonyId && !currentId) {
          // User logged out
          setMessages([]);
          setInput("");
          setConnectionStatus("disconnected");
        }
        setMatrimonyId(currentId);
      }
    };

    const handleStorageChange = (e) => {
      if (e.key === "MatrimonyId") {
        handleAuthChange();
      }
    };

    const interval = setInterval(handleAuthChange, 5000);

    window.addEventListener("storage", handleStorageChange);

    return () => {
      clearInterval(interval);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [matrimonyId]);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const fetchMessages = async () => {
    if (!matrimonyId || isFetching) return;

    setIsFetching(true);

    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        setConnectionStatus("disconnected");
        return;
      }

      const getUrl = `https://backend.newbrindha.com/matrimony/chat/admin/messages?matrimony_id=${matrimonyId}&t=${Date.now()}`;

      const response = await axios.get(getUrl, {
        headers: { Authorization: `Bearer ${token}` },
        timeout: 10000,
      });

      if (response.data && Array.isArray(response.data)) {
        const formattedMessages = response.data
          .map((msg) => ({
            id: `${msg.timestamp}-${msg.sender_id}`,
            sender: msg.sender_id === "admin" ? "admin" : "user",
            text: msg.message,
            timestamp: msg.timestamp,
          }))
          .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));

        setMessages(formattedMessages);
        setConnectionStatus("connected");
      }
    } catch (err) {
      console.error("Chat: Error fetching messages:", err);
      setConnectionStatus("error");
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    let interval;

    if (open && matrimonyId) {
      fetchMessages();

      if (connectionStatus !== "connected") {
        interval = setInterval(fetchMessages, 3000);
      }
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [open, matrimonyId, connectionStatus]);

  const handleSend = async () => {
    if (!input.trim() || !matrimonyId || isLoading) return;

    const userMsg = {
      id: `user-${Date.now()}`,
      sender: "user",
      text: input.trim(),
      timestamp: new Date().toISOString(),
    };

    setMessages((prev) => [...prev, userMsg]);
    setInput("");
    setIsLoading(true);

    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        throw new Error("Authentication token not found");
      }

      await axios.post(
        "https://backend.newbrindha.com/matrimony/chat/user-to-admin",
        {
          message: input.trim(),
          sender_id: matrimonyId,
          receiver_email: ADMIN_EMAIL,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          timeout: 10000,
        },
      );

      await fetchMessages();
    } catch (err) {
      console.error("Chat: Error sending message:", err);
      setMessages((prev) => prev.filter((msg) => msg.id !== userMsg.id));
      setInput(userMsg.text);
      setTimeout(handleSend, 2000);
    } finally {
      setIsLoading(false);
    }
  };

  const getConnectionStatus = () => {
    switch (connectionStatus) {
      case "connected":
        return (
          <div className="flex items-center text-xs text-green-600">
            <div className="w-2 h-2 bg-green-500 rounded-full mr-1"></div>
            Connected
          </div>
        );
      case "connecting":
        return (
          <div className="flex items-center text-xs text-amber-600">
            <div className="w-2 h-2 bg-amber-500 rounded-full mr-1 animate-pulse"></div>
            Connecting...
          </div>
        );
      case "error":
        return (
          <div className="flex items-center text-xs text-amber-600">
            <div className="w-2 h-2 bg-amber-500 rounded-full mr-1"></div>
            Reconnecting...
          </div>
        );
      default:
        return (
          <div className="flex items-center text-xs text-gray-500">
            <div className="w-2 h-2 bg-gray-400 rounded-full mr-1"></div>
            Disconnected
          </div>
        );
    }
  };

  return (
    <div
      className="fixed bottom-6 right-6 z-50"
      style={{ width: "auto", height: "auto" }}
    >
      {!open && (
        <button
          onClick={() => setOpen(true)}
          className="bg-gradient-to-r from-amber-500 to-orange-500 text-white p-4 rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-110"
          aria-label="Open chat"
        >
          <MessageCircle className="w-6 h-6" />
        </button>
      )}

      {open && (
        <div className="w-80 bg-white rounded-2xl shadow-2xl flex flex-col overflow-hidden border border-gray-200 transition-all duration-300 hover:shadow-3xl">
          <div className="bg-gradient-to-r from-amber-500 to-orange-500 text-white px-4 py-3 flex justify-between items-center">
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-white rounded-full"></div>
              <span className="font-medium">Admin Chat</span>
            </div>
            <div className="flex items-center space-x-3">
              {getConnectionStatus()}
              <button
                onClick={() => setOpen(false)}
                className="p-1 rounded-full hover:bg-white/20 transition-colors duration-200 hover:rotate-90"
                aria-label="Close chat"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
          </div>

          <div className="flex-1 p-4 space-y-3 overflow-y-auto max-h-80 bg-gray-50">
            {!matrimonyId ? (
              <div className="text-center p-4 text-sm bg-amber-50 rounded-lg border border-amber-100 text-amber-800 hover:bg-amber-100 transition-colors duration-200">
                Please login to access chat
              </div>
            ) : isFetching && messages.length === 0 ? (
              <div className="flex justify-center items-center h-40">
                <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-amber-500"></div>
              </div>
            ) : messages.length === 0 ? (
              <div className="text-center p-4 text-sm bg-amber-50 rounded-lg border border-amber-100 text-amber-800 hover:bg-amber-100 transition-colors duration-200">
                <div className="mb-2 hover:scale-110 transition-transform duration-300">
                  👋
                </div>
                <div>Welcome! Send a message to chat with our admin.</div>
              </div>
            ) : (
              messages.map((msg) => (
                <div
                  key={msg.id}
                  className={`flex ${msg.sender === "user" ? "justify-end" : "justify-start"}`}
                >
                  <div
                    className={`px-4 py-2 rounded-2xl max-w-[80%] transition-all duration-200 ${
                      msg.sender === "user"
                        ? "bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-br-none hover:from-amber-600 hover:to-orange-600"
                        : "bg-white text-gray-800 rounded-bl-none shadow-sm border border-gray-200 hover:bg-gray-100"
                    }`}
                  >
                    {msg.text}
                    <div
                      className={`text-xs mt-1 ${msg.sender === "user" ? "text-amber-100" : "text-gray-500"}`}
                    >
                      {new Date(msg.timestamp).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </div>
                  </div>
                </div>
              ))
            )}
            <div ref={messagesEndRef} />
          </div>

          <div className="border-t border-gray-200 p-3 bg-white">
            <div className="flex items-center">
              <input
                className="flex-1 border border-gray-300 rounded-l-full px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent hover:border-amber-400 transition-colors duration-200"
                type="text"
                value={input}
                placeholder={
                  matrimonyId ? "Type your message..." : "Please login to chat"
                }
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleSend()}
                disabled={isLoading || !matrimonyId}
              />
              <button
                className="bg-gradient-to-r from-amber-500 to-orange-500 text-white p-2 rounded-r-full hover:opacity-90 transition-all duration-300 disabled:opacity-50 hover:from-amber-600 hover:to-orange-600"
                onClick={handleSend}
                disabled={!input.trim() || isLoading || !matrimonyId}
              >
                {isLoading ? (
                  <div className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full"></div>
                ) : (
                  <ArrowUp className="w-4 h-4 hover:scale-125 transition-transform duration-200" />
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatWidget;
